module.exports = __webpack_public_path__ + "img/logoDec.d3873918.png";